/* esm.sh - use-sidecar@1.1.3 */
export * from "/*use-sidecar@1.1.3/esnext/use-sidecar.mjs";
